import React from 'react';

import { useWarehouseContext } from 'providers/WarehouseProvider';

import Table from 'components/common/Table';

import { grnApi } from 'api';

import {
  getGrnListTab,
  GRN_LIST_COLUMNS,
  GRN_FILTER_OPTIONS,
} from 'constants/grn';

const Grn = () => {
  const { selectedWarehouse } = useWarehouseContext();
  const initialFilter = { warehouse: selectedWarehouse?.id };

  return (
    <Table
      title="GRN List"
      apiService={grnApi}
      sortable={true}
      columns={GRN_LIST_COLUMNS}
      filterOptions={GRN_FILTER_OPTIONS}
      tabOptions={getGrnListTab(initialFilter)}
      initialFilter={initialFilter}
    />
  );
};

export default Grn;
